import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 86917 86918"
    {...props}
  >
    <path
      d="M54125 32810 43493 0 32809 32793 0 43425l32793 10683 10631 32810 10684-32792 32809-10633z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
